import { Bar as VisxBar } from '@visx/shape';
import { getSafeZero } from '../utils';
import type { BarProps } from './types';
import { calculateBarWidth } from './utils';

const Bar = ({
  data,
  xScale,
  xSelect,
  yScale,
  ySelect,
  fillPos,
  fillNeg,
  maxWidth,
}: BarProps) => {
  const GAP = 2;
  const DEFAULT_WIDTH = 10;
  const calculatedWidth = calculateBarWidth({
    data,
    xScale,
    xSelect,
    maxWidth,
  });

  const width =
    calculatedWidth === Infinity
      ? DEFAULT_WIDTH
      : Math.max(calculatedWidth - GAP, 1);

  const zero = getSafeZero(yScale);

  return (
    <>
      {yScale.domain()[1] > 0 && (
        <svg y="0" x="0" width="100%" height={zero}>
          {data.map((d, i) => {
            const y = yScale(ySelect(d));
            return (
              y <= zero && (
                <VisxBar
                  key={`bar-${i}`}
                  x={xScale(xSelect(d)) - width / 2}
                  y={y}
                  width={width}
                  height="100%"
                  fill={fillPos}
                />
              )
            );
          })}
        </svg>
      )}
      {yScale.domain()[0] < 0 && (
        <svg y={zero} x="0" width="100%" height="100%">
          {data.map((d, i) => {
            const y = yScale(ySelect(d));

            return (
              y > zero && (
                <VisxBar
                  key={`bar-${i}`}
                  x={xScale(xSelect(d)) - width / 2}
                  y={y}
                  width={width}
                  height="100%"
                  fill={fillNeg}
                />
              )
            );
          })}
        </svg>
      )}
    </>
  );
};

export default Bar;
